import { useLanding } from '@/components/Landing/LandingKit';
import { businessBrand } from './businessBrandPalette';
export { businessBrand } from './businessBrandPalette';

export default function useBusinessBrand() {
  return businessBrand(!!useLanding().isDark);
}
